<div class="row counter-cards">
    <div class="col-sm-6 col-md-6 col-lg-3 mt-3">
        <div class="card">
            <div class="row">
                <div class="col-12 col-sm-7">
                    <div class="content">
                        <p class="font-18">{{'guests.Visits' | translate}}<br><span
                                class="bold-number">{{restaurantProfile?.statistics?.visits}}</span>
                        </p>
                    </div>
                </div>
                <div class="col-12 col-sm-5">
                    <svg xmlns="http://www.w3.org/2000/svg" width="98.995" height="98.995"
                        viewBox="0 0 98.995 98.995">
                        <g id="Icon" transform="translate(-640.503 -449.502)">
                            <rect id="Rec-bg" width="70" height="70" rx="10"
                                transform="translate(690 449.502) rotate(45)" fill="#fef3e5" />
                            <path id="visits-ic"
                                d="M17.949,25a1.35,1.35,0,0,1,0-2.7h.758V10.668H11.461a1.349,1.349,0,1,1,0-2.7h5.183a2.158,2.158,0,0,1-1.6-2.091.656.656,0,0,1,.424-.616A4.82,4.82,0,0,1,16.79,2.49,4.6,4.6,0,0,1,18.712,1.3,1.384,1.384,0,0,1,20,0h.067a1.384,1.384,0,0,1,1.347,1.3,4.6,4.6,0,0,1,1.926,1.194,4.811,4.811,0,0,1,1.312,2.772.6.6,0,0,1,.238.153.658.658,0,0,1,.184.459,2.16,2.16,0,0,1-.639,1.531,2.09,2.09,0,0,1-1,.563h5.217a1.349,1.349,0,0,1,0,2.7H21.4V22.3h.758a1.35,1.35,0,1,1,0,2.7ZM17.12,6.732h5.833a.881.881,0,0,0,.552-.208H16.578A.836.836,0,0,0,17.12,6.732Zm-.39-1.5h6.656a3.426,3.426,0,0,0-3.3-2.84H20.03A3.427,3.427,0,0,0,16.73,5.229ZM13.087,24.175,10.437,17.9l-4.2,0L3.585,24.175A1.348,1.348,0,1,1,1.1,23.127L4,16.248H3.493A1.35,1.35,0,0,1,2.177,15.19L.032,5.451A1.349,1.349,0,0,1,2.666,4.87l1.91,8.678h8.6a1.349,1.349,0,0,1,0,2.7h-.511l2.906,6.882a1.348,1.348,0,1,1-2.484,1.047Z"
                                transform="translate(675 486)" fill="#f8a02a" />
                        </g>
                    </svg>
                </div>
            </div>
        </div>
    </div>
    <div class="col-sm-6 col-md-6 col-lg-3 mt-3">
        <div class="card">
            <div class="row">
                <div class="col-12 col-sm-7">
                    <div class="content">
                        <p class="font-18">{{'restaurant.Staff' | translate}}<br><span
                                class="bold-number">{{restaurantProfile?.statistics?.staff}}</span></p>
                    </div>
                </div>
                <div class="col-12 col-sm-5">
                    <div>
                        <svg xmlns="http://www.w3.org/2000/svg" width="98.995" height="98.995"
                            viewBox="0 0 98.995 98.995">
                            <g id="Icon" transform="translate(-641.001 -450)">
                                <rect id="Rec-bg" width="70" height="70" rx="10"
                                    transform="translate(690.498 450) rotate(45)" fill="#fef3e5" />
                                <path id="staff-ic"
                                    d="M23.949,25A1.507,1.507,0,0,0,25.5,23.559c0-5.305-4.1-9.874-9.753-10.866A12.977,12.977,0,0,1,18,12.5c6.619,0,12,4.962,12,11.062A1.508,1.508,0,0,1,28.435,25ZM1.564,25A1.511,1.511,0,0,1,0,23.559C0,17.462,5.385,12.5,12,12.5s12,4.964,12,11.062A1.511,1.511,0,0,1,22.438,25ZM15.749,10.573a5.477,5.477,0,0,0,0-10.115A5.677,5.677,0,0,1,18,0a5.574,5.574,0,0,1,5.624,5.513A5.577,5.577,0,0,1,18,11.031,5.7,5.7,0,0,1,15.749,10.573ZM6.378,5.513a5.625,5.625,0,0,1,11.247,0,5.625,5.625,0,0,1-11.247,0Z"
                                    transform="translate(675 487)" fill="#f8a02a" />
                            </g>
                        </svg>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="col-sm-6 col-md-6 col-lg-3 mt-3">
        <div class="card">
            <div class="row">
                <div class="col-12 col-sm-7">
                    <div class="content">
                        <p class="font-18">{{'restaurant.Rate' | translate}}<br><span
                                class="bold-number">{{restaurantProfile?.statistics?.rate}}</span></p>
                    </div>

                </div>
                <div class="col-12 col-sm-5">
                    <svg xmlns="http://www.w3.org/2000/svg" width="98.995" height="98.995"
                        viewBox="0 0 98.995 98.995">
                        <g id="Icon" transform="translate(-641.001 -450)">
                            <rect id="Rec-bg" width="70" height="70" rx="10"
                                transform="translate(690.498 450) rotate(45)" fill="#fef3e5" />
                            <path id="star-half-ic"
                                d="M31.955,13.022a1.492,1.492,0,0,0-1.288-.98l-8.523-1.215-3.82-7.566a1.514,1.514,0,0,0-2.7,0l-3.82,7.551L3.285,12.042a1.489,1.489,0,0,0-1.213,1A1.44,1.44,0,0,0,2.446,14.5l6.186,5.854-1.5,8.312a1.447,1.447,0,0,0,.578,1.486,1.527,1.527,0,0,0,1.624.095l7.639-3.907,7.639,3.907a1.419,1.419,0,0,0,.689.176,1.522,1.522,0,0,0,.884-.278,1.448,1.448,0,0,0,.6-1.463l-1.5-8.312,6.186-5.854A1.443,1.443,0,0,0,31.955,13.022Z"
                                transform="translate(672.994 482.564)" fill="#f8a02a" />
                        </g>
                    </svg>
                </div>
            </div>
        </div>
    </div>
    <div class="col-sm-6 col-md-6 col-lg-3 mt-3">
        <div class="card">
            <div class="row">
                <div class="col-12 col-sm-7">
                    <div class="content">
                        <p class="font-18">{{'restaurant.Complaints' | translate}}<br><span
                                class="bold-number">{{restaurantProfile?.statistics?.complaints}}</span></p>
                    </div>
                </div>
                <div class="col-12 col-sm-5">
                    <svg xmlns="http://www.w3.org/2000/svg" width="98.995" height="98.995"
                        viewBox="0 0 98.995 98.995">
                        <g id="Icon" transform="translate(-641.001 -450)">
                            <rect id="Rec-bg" width="70" height="70" rx="10"
                                transform="translate(690.498 450) rotate(45)" fill="#fef3e5" />
                            <path id="thumbs-down-ic"
                                d="M27.5,2H8.4A4.5,4.5,0,0,0,3.98,5.69l-1.905,10.5A4.5,4.5,0,0,0,6.5,21.5h6.84l-.84,2.145A6.2,6.2,0,0,0,18.335,32a1.5,1.5,0,0,0,1.365-.885L23.976,21.5H27.5A4.5,4.5,0,0,0,32,17V6.5A4.5,4.5,0,0,0,27.5,2ZM29,17a1.5,1.5,0,0,1-1.5,1.5h-3V5h3A1.5,1.5,0,0,1,29,6.5Z"
                                transform="translate(673 482)" fill="#f8a02a" />
                        </g>
                    </svg>
                </div>
            </div>
        </div>
    </div>
</div>